import { forwardRef, useRef } from 'react';

const PICKER_TYPES = new Set(['date', 'datetime-local', 'month', 'week']);

export const UiInput = forwardRef(function UiInput(
  { label, error, className = '', style, inputClassName = '', type, onClick, onMouseDown, ...inputProps },
  ref,
) {
  const wasFocusedRef = useRef(false);

  const handleMouseDown = (event) => {
    // Запоминаем, был ли инпут в фокусе ДО этого клика: focus проставляется на mousedown.
    wasFocusedRef.current = document.activeElement === event.currentTarget;
    onMouseDown?.(event);
  };

  const handleClick = (event) => {
    const input = event.currentTarget;
    // Открываем нативный пикер только на клике, который впервые фокусирует поле,
    // чтобы повторные клики по сегментам и ручной ввод с клавиатуры не перехватывались.
    if (
      PICKER_TYPES.has(type)
      && !wasFocusedRef.current
      && typeof input.showPicker === 'function'
      && !input.disabled
      && !input.readOnly
    ) {
      try {
        input.showPicker();
      } catch {
        // Пикер может быть недоступен в некоторых браузерах — ручной ввод остаётся рабочим.
      }
    }
    onClick?.(event);
  };

  return (
    <label className={`ui-field ${className}`.trim()} style={style}>
      {label ? <span className="ui-field__label">{label}</span> : null}
      <input
        {...inputProps}
        type={type}
        ref={ref}
        onMouseDown={handleMouseDown}
        onClick={handleClick}
        className={`ui-control ${inputClassName}`.trim()}
      />
      {error ? <span className="form-error">{error}</span> : null}
    </label>
  );
});
